import React from 'react'

const Pipes = (props) => {
    return (
        <div className="col-md-4">
            <div className="">
                <p className="text-muted mb-0 font-size-9">Pipes</p>
                <h5 className="font-size-10">{props.entityCount}</h5>
            </div>
        </div>
    )
}

export default Pipes
